import { useState } from "react";

export const useDate = ({ type, name }) => {
  const [value, setValue] = useState("");

  const onChange = (event) => setValue(event);

  return {
    type,
    name,
    value,
    onChange,
  };
};
